<template>
  <TemplateOnboarding
    type="settings"
    :loading="loading"
    :footer="false"
  >
    <section class="manage-subscription-section">
      <div
        v-if="error"
        class="error body--small"
      >
        {{ error }}
      </div>

      <div
        v-if="loading"
        class="body--small"
      >
        {{ StripeCopy.MANAGE_SUBSCRIPTION.INITIALIZING_CHECKOUT }}
      </div>

      <div class="checkout-wrapper">
        <div class="checkout-container">
          <div
            ref="checkout"
            class="checkout"
          />
        </div>
      </div>
    </section>
  </TemplateOnboarding>
</template>

<script>
import TemplateOnboarding from "@/components/template/onboarding/index.vue";
import services from "@/services";
import { RoutesEnum, StripeCopy, SettingsEnum } from "@/enums";
import { initStripeCheckout } from "@/utils/stripe";

export default {
  name: "ManageSubscription",

  components: {
    TemplateOnboarding,
  },

  data() {
    return {
      SettingsEnum,
      StripeCopy,
      RoutesEnum,
      loading: false,
      error: "",
      embeddedCheckout: null,
      initializing: false,
    };
  },

  async mounted() {
    await this.$nextTick();
    await this.initCheckout();
  },

  async beforeUnmount() {
    try {
      if (this.embeddedCheckout?.destroy) {
        this.embeddedCheckout.destroy();
      }
    } catch (err) {
      console.error("[ManageSubscription] Failed to destroy embedded checkout", err);
    } finally {
      this.embeddedCheckout = null;
    }
  },

  methods: {
    async initCheckout() {
      if (this.initializing) return;

      this.initializing = true;
      this.loading = true;
      this.error = "";

      try {
        const { clientSecret, alreadySubscribed } = await services.billing.createCheckoutSession();

        if (alreadySubscribed) {
          this.$router.push(RoutesEnum.BUSINESS_DASHBOARD);
          return;
        }

        if (!clientSecret) {
          throw new Error(StripeCopy.MANAGE_SUBSCRIPTION.CHECKOUT_INIT_FAILED);
        }

        this.loading = false;
        await this.$nextTick();

        this.embeddedCheckout = await initStripeCheckout(clientSecret, this.$refs.checkout);

      } catch (err) {
        console.error("[ManageSubscription] initCheckout failed", err);
        this.error = err?.message || StripeCopy.MANAGE_SUBSCRIPTION.GENERIC_ERROR;
      } finally {
        this.loading = false;
        this.initializing = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.manage-subscription-section {
  @include stack-space($space-large);
  @include inset-space($space-large);
  align-items: flex-start;

  .checkout-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .checkout-container {
    width: 100%;
    max-width: 520px;
  }

  .checkout {
    min-height: 640px;
  }

  .error {
    color: $color-semantics-error;
  }
}
</style>